import { productReference } from '@theme/project-utils';

// Old inbound inquiry links retain variant context; /pages/contact remains general contact.
const link = document.querySelector('[data-wood-project-destination]');
if (link instanceof HTMLAnchorElement) {
  const current = new URL(location.href);
  if (current.hash === '#ProjectInquiry' || current.searchParams.has('product_request')) {
    const target = new URL(link.href);
    const reference = productReference(current.searchParams.get('product_request'), location.origin);
    if (reference) target.searchParams.set('product_request', reference.url);
    location.replace(target.href);
  }
}
